import React from 'react';
import { render } from 'react-dom';
import {parseDataToProps} from "../../helpers";

const checkoutNodes = document.querySelectorAll('.checkout');

if (checkoutNodes.length > 0) {
    import(/* webpackChunkName: "ObservingCheckout" */ './components/Checkout').then(({ObservingCheckout: ObservingCheckout}) => {
        [...checkoutNodes].forEach((node) => render(<ObservingCheckout {...parseDataToProps(node.dataset)} />, node));
    });
}
